import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const productCategoryApi = createApi({
  reducerPath: "productCategoryApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["ProductCategory"],
  endpoints: (build) => ({
    listProductCategories: build.query<
      ProductCategory[],
      { companyId: number; serviceId: number; search?: string }
    >({
      query: ({ companyId, serviceId, search }) => ({
        url: `${companyId}/services/${serviceId}/product-category`,
        method: "GET",
        params: search ? { search } : undefined,
      }),
      providesTags: ["ProductCategory"],
    }),
    createProductCategory: build.mutation<
      void,
      { companyId: number; serviceId: number; data: ProductCategoryData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: `${companyId}/services/${serviceId}/product-category`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ProductCategory"],
    }),
    editProductCategory: build.mutation<
      void,
      {
        companyId: number;
        serviceId: number;
        categoryId: number;
        data: ProductCategoryData;
      }
    >({
      query: ({ companyId, serviceId, categoryId, data }) => ({
        url: `${companyId}/services/${serviceId}/product-category/${categoryId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ProductCategory"],
    }),
    deleteProductCategory: build.mutation<
      void,
      { companyId: number; serviceId: number; categoryId: number }
    >({
      query: ({ companyId, serviceId, categoryId }) => ({
        url: `${companyId}/services/${serviceId}/product-category/${categoryId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProductCategory"],
    }),
  }),
});
